import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { type IMultiDayJobPayload, type IPostMultiDayRawResponse } from '../types';

export async function postMultiDayShifts(
  officeId: string,
  jobInfo: IMultiDayJobPayload[],
): Promise<IPostMultiDayRawResponse> {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.post<IPostMultiDayRawResponse>('/multi-day', jobInfo, {
    headers: {
      ...headers,
      'x-office': officeId,
    },
  });

  return response.data;
}
